var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLinkdin(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 27,
    height: 24,
    viewBox: "0 0 27 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_803_12015)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.12993 5.70126C4.60968 5.70126 5.81064 4.5003 5.81064 3.02056C5.81064 1.5408 4.60968 0.339844 3.12993 0.339844C1.65018 0.339844 0.449219 1.5408 0.449219 3.02056C0.449219 4.5003 1.65018 5.70126 3.12993 5.70126ZM0.449219 23.573V7.48864H5.81064V23.573H0.449219ZM9.38585 7.48864H14.3309V10.0228H14.4024C15.0903 8.7879 16.7738 7.48864 19.2848 7.48864C24.5051 7.48864 25.4701 10.7377 25.4701 14.9642V23.573H20.3142V15.9418C20.3142 14.1225 20.2766 11.7796 17.6335 11.7796C14.9493 11.7796 14.5382 13.7615 14.5382 15.8096V23.573H9.38585V7.48864Z",
    fill: "black",
    fillOpacity: 0.6
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_803_12015"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 25.8146,
    height: 23.2331,
    fill: "white",
    transform: "translate(0.449219 0.339844)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkdin);
export default __webpack_public_path__ + "static/media/linkdin.3883a54a05453f907f0c7202da8a8015.svg";
export { ForwardRef as ReactComponent };